import { apiGet, apiPost } from "./apiClient";
import { Idea } from "../types";

export interface SpotlightItem {
  id: string;
  ideaId: string;
  userId: string;
  idea: Idea;
  startTime: string;
  endTime: string;
  impressions: number;
}

export interface CreditBalance {
  userId: string;
  balance: number;
}

export interface SpotlightConfig {
  limit: number;
  cost: number;
}

export const spotlightApi = {
  /**
   * Fetch the currently active spotlight items for the given time block.
   */
  getActiveSpotlights: async () => {
    return apiGet<{ items: SpotlightItem[] }>("/spotlights/active");
  },

  /**
   * Fetch the dynamic spotlight configuration.
   */
  getSpotlightConfig: async () => {
    return apiGet<SpotlightConfig>("/spotlights/config");
  },

  /**
   * Fetch the user's current credit balance.
   */
  getUserCredits: async () => {
    return apiGet<CreditBalance>("/users/me/credits");
  },

  /**
   * Purchase a spotlight slot.
   */
  purchaseSpotlightSlot: async (ideaId: string, durationHours: number = 24) => {
    return apiPost<{ success: boolean; item: SpotlightItem }>("/spotlights/purchase", {
      ideaId,
      durationHours,
    });
  },
};
